import { match } from '@frontend/duck-tape';
import { type CreateTaskStep } from '@frontend/react-domain/hooks/useGlobalTaskCreation/helpers';
import { Modal, YStack } from '@frontend/web-react';
import { Quota } from '@frontend/web/components/DomainSpecific/Tasks/CreateTaskModal/Quota';
import { useCreateTaskContext } from '@frontend/web/hooks/context/useCreateTaskContext';
import type { ReactNode } from 'react';
import { Description } from './Description';
import { InitialQuestions } from './InitialQuestions';
import { NextSteps } from './NextSteps';
import { RecurrenceSettings } from './RecurrenceSettings';

export const CreateTaskModal = () => {
  const { closeCreateTaskModal, createTaskState, isCreateTaskModalOpen } = useCreateTaskContext();

  const isTaskInProgress =
    createTaskState.taskData.description.length > 0 || createTaskState.taskData.attachments.length > 0;

  return (
    <Modal
      confirmOnClose={isTaskInProgress}
      confirmOnCloseMessage="If you close the task window, you will lose your progress."
      contentBorderRadius="rounded-lg"
      isOpen={isCreateTaskModalOpen}
      onClose={closeCreateTaskModal}
      padding="none"
      size="600px"
      // Mantine sets zIndex to 200 by default. We want this to be above any other dialogs/modals.
      // Date pickers have a zIndex of 300, so we set this to 299 to be below date inputs but above other modals them.
      zIndex={299}
    >
      <YStack gapY="md">
        {match<CreateTaskStep, ReactNode>(createTaskState.currentStep)
          // eslint-disable-next-line react/jsx-no-useless-fragment
          .with('init', () => <></>)
          .with('description', () => <Description />)
          .with('quota', () => <Quota />)
          .with('recurrenceSettings', () => <RecurrenceSettings />)
          .with('nextSteps', () => <NextSteps />)
          .with('initialQuestions', () => <InitialQuestions />)
          .exhaustive()}
      </YStack>
    </Modal>
  );
};
